import Papa from 'papaparse';
import * as XLSX from 'xlsx';
import { AttachmentValue } from '@lib/components/FileUploaderUppy/FileUploaderUppy';

export type ParsedData = Record<string, string | number | boolean | null>;

export const readFileData = (
  attachment: AttachmentValue,
): Promise<ParsedData[]> => {
  const { file, filename } = attachment;
  const extension = filename?.split('.').pop()?.toLowerCase();

  return new Promise((resolve, reject) => {
    if (!file) {
      reject(new Error('No file provided'));
      return;
    }

    if (!extension) {
      reject(new Error('No file extension'));
      return;
    }

    const reader = new FileReader();

    reader.onerror = () => {
      reject(new Error('Error reading file'));
    };

    if (extension === 'csv') {
      reader.onload = () => {
        const text = reader.result as string;

        Papa.parse<ParsedData>(text, {
          header: false,
          skipEmptyLines: true,
          complete: (result) => {
            resolve(result.data);
          },
          error: (err) => {
            reject(err);
          },
        });
      };

      reader.readAsText(file as File);
    } else if (extension === 'xlsx') {
      reader.onload = () => {
        const data = new Uint8Array(reader.result as ArrayBuffer);
        const workbook = XLSX.read(data, { type: 'array' });

        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json<ParsedData>(worksheet, {
          defval: null,
          header: 1,
          skipHidden: true,
        });

        resolve(jsonData);
      };

      reader.readAsArrayBuffer(file as File);
    } else {
      reject(new Error('Unsupported file type'));
    }
  });
};
